<template>
  <div v-if="icon" :key="Status" class="policy-status" :style="{'color': color }">
    <i :class="icon"></i>
    <div class="policy-status-text">{{text}}</div>
  </div>
</template>

<script>

export default {
  name: 'PolicyStatus',
  data () {
    return {
    };
  },
  props: {
    Status: {
      type: String,
      default: ""
    }
  },
  computed: {
    icon () {
      switch (this.Status) {
        case "Incomplete": return ['fa-solid', 'fa-exclamation'];
        case "Bound": return ['fa-solid', 'fa-check'];
        case "UpcomingTerm": return ['fa-solid', 'fa-file-alt'];
        case "Renewed": return ['fa-solid', 'fa-file-alt'];
        case "Active": return ['fa-solid', 'fa-file-alt'];
        case "RenewalOffered": return ['fa-solid', 'fa-clock'];
        case "RenewalDeclined": return ['fa-regular', 'fa-xmark-to-slot'];
        case "Lapsed": return ['fa-solid', 'fa-history'];
        case "Canceled": return ['fa-solid', 'fa-history'];
        case "Expired": return ['fa-solid', 'fa-times'];
        case "Declined": return ['fa-solid', 'fa-times'];
        case "Submitted": return ['fa-solid', 'fa-check'];
        case "Quoted": return ['fa-solid', 'fa-check'];
        case "Rejected": return ['fa-solid', 'fa-times'];
        case "Issued": return ['fa-solid', 'fa-check'];
        case "BindRequest": return ['fa-solid', 'fa-clock'];
        default: return null;
      }
    },
    color () {
      let color = null;
      switch (this.Status) {
        case "Incomplete":
        case "Lapsed":
        case "NonRenewed":
        case "Canceled":
        case "Expired":
        case "Declined":
        case "BindRequest":
          color = "#333333";
          break;
        case "Bound":
        case "Submitted":
        case "Quoted":
          color = "#215479";
          break;
        case "Active":
        case "Issued":
          color = "#00953B";
          break;
        case "Renewed":
        case "RenewalOffered":
          color = "#fdb714";
          break;
        case "UpcomingTerm":
          color = "#3778A2";
          break;
        case "RenewalDeclined":
          color = "#E14A2B";
          break;
        case "Rejected":
          color = "#9F2242";
          break;
        default:
          break;
      }
      return color;
    },
    text () {
      let text = this.Status;
      switch (this.Status) {
        case "UpcomingTerm": text = "Upcoming Term"; break;
        case "RenewalOffered": text = "Renewal Offered"; break;
        case "NonRenewed": text = "Non-Renewed"; break;
        case "RenewalDeclined": text = "Renewal Declined"; break;
        case "BindRequest": text = "Bind Request"; break;
        default: break;
      }
      return text;
    }
  }
};
</script>

<style scoped lang="scss">
.policy-status {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.policy-status-text {
  padding-left: 5px;
}
</style>
